function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { DeleteButton, Button } from '@rd-web-markets/shared/dist/util/buttons';
import isEqual from 'lodash.isequal';
import FileUpload from '@rd-web-markets/shared/dist/util/FileUpload';
import { useFileUpload } from '@rd-web-markets/shared/dist/hooks';
import { useTranslation } from 'react-i18next';
import omit from 'lodash.omit';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import HalfYearDropdown from '../HalfYearDropdown';
const NameListTableData = _ref => {
  let {
    isSaved,
    notSavedStyle,
    body,
    setBody,
    saveData,
    rowData,
    uploadFile,
    deleteData,
    data,
    uploadAllowed,
    setUploadAllowed,
    createNewData,
    removeEmptyRow,
    emptyRowId,
    showHalfYearColumn,
    elsterYearForStaffCost
  } = _ref;
  const [file, isFileUploadLoading, setFile] = useFileUpload(!!body.id ? uploadFile : createNewData, 'document', uploadAllowed);
  const {
    t
  } = useTranslation();
  const submit = function () {
    let bodyToSave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : body;
    if (!!rowData.id) {
      saveData(bodyToSave);
    } else if (!file) {
      createNewData(new FormData(), bodyToSave);
    } else {
      setUploadAllowed(true);
    }
  };
  const changeBody = e => {
    const key = e.target.name;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const finalValue = ['rel_agreed_annual_working_hrs'].includes(key) && !!value.length ? Number(value) : value;
    const updatedBody = _objectSpread(_objectSpread({}, body), {}, {
      [key]: finalValue
    });
    if (key === 'year') {
      setBody(updatedBody);
      submit(updatedBody);
      return;
    }
    if (e.target.type === 'checkbox' && !!rowData.id) {
      if (key === 'fulltime' && value === true) {
        //reset specific data to original when fulltime is checked
        saveData(updatedBody);
        setBody(updatedBody);
      } else {
        saveData(updatedBody);
        setBody(updatedBody);
      }
      return;
    }
    setBody(updatedBody);
  };
  const filenameLink = rowData.document ? /*#__PURE__*/React.createElement("a", {
    href: rowData.document.url,
    target: "_blank",
    rel: "noreferrer"
  }, rowData.document.filename) : /*#__PURE__*/React.createElement("p", null, t('no_file_has_been_uploaded'));
  const saveOnBlur = () => {
    submit();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
    style: isSaved ? {} : notSavedStyle
  }, /*#__PURE__*/React.createElement(Form.Control, {
    onBlur: saveOnBlur,
    value: body.employee_name_number,
    name: "employee_name_number",
    onChange: changeBody,
    size: "md",
    type: "text"
  })), showHalfYearColumn && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(HalfYearDropdown, {
    elsterYear: elsterYearForStaffCost,
    value: body.year,
    onChange: val => changeBody({
      target: {
        name: 'year',
        value: val
      }
    }),
    dataTestId: "name_list_year"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "bda",
    checked: body.bda,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "fulltime",
    checked: body.fulltime,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "digital_record",
    disabled: body.fulltime,
    checked: body.fulltime ? false : body.digital_record,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 1,
    onChange: changeBody,
    object: body === null || body === void 0 ? void 0 : body.calculations,
    name: "share_of_working_time",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 2,
    onChange: changeBody,
    onBlur: saveOnBlur,
    object: body,
    name: "rel_agreed_annual_working_hrs",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: body.fulltime
  })), /*#__PURE__*/React.createElement("td", null, filenameLink), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FileUpload, {
    loading: isFileUploadLoading,
    title: t('upload_document'),
    file: file,
    onSelectFile: setFile
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeleteButton, {
    style: {
      marginRight: '8px'
    },
    onClick: () => emptyRowId !== null ? removeEmptyRow(emptyRowId) : deleteData(body, data),
    "data-testid": "delete_button"
  }))));
};
export default NameListTableData;